"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.muiTheme = exports.default = exports.Theme = exports.ScrollableStyles = exports.ScreenSize = void 0;
var _core = require("@material-ui/core");
const palette = {
  white: '#ffffff',
  guyabanoGray: '#F5F5F5',
  silverChalice: '#ADADAD',
  black: '#000000',
  darkBlue: '#061f33',
  midnightBlue: '#1e3547',
  gambogOrange: '#ffb300',
  goldenrodOrange: '#dda93a',
  electricRed: '#e42a11',
  ogreOdor: '#f15b47',
  wasabiGreen: '#48b648',
  vividGreen: '#01cd3e',
  trueBlue: '#0064E9'
};
const Theme = exports.Theme = {
  color: {
    feature: palette.darkBlue,
    featureActive: palette.midnightBlue,
    primary: palette.trueBlue,
    secondary: palette.silverChalice,
    accent: palette.wasabiGreen,
    link: palette.trueBlue,
    white: palette.white,
    black: palette.black,
    success: palette.vividGreen,
    danger: palette.electricRed,
    info: palette.trueBlue,
    warning: palette.gambogOrange,
    muted: palette.silverChalice,
    light: palette.guyabanoGray
  },
  font: {
    baseColor: palette.darkBlue,
    mutedColor: palette.muted,
    smallSize: '12px',
    baseSize: '14px',
    mediumSize: '16px',
    largeSize: '18px',
    xlSize: '24px',
    megaSize: '32px',
    boldWeight: '600',
    baseWeight: '400',
    baseFamily: 'Roboto, sans-serif, serif',
    fancyFamily: 'Montserrat, sans-serif, serif',
    codeFamily: 'Source Code Pro, monospace'
  }
};
const muiTheme = exports.muiTheme = (0, _core.unstable_createMuiStrictModeTheme)({
  overrides: {
    MuiButton: {
      root: {
        paddingLeft: '30px !important',
        paddingRight: '30px !important',
        fontSize: "".concat(Theme.font.baseSize, " !important")
      },
      containedSizeLarge: {
        height: 46,
        fontSize: "".concat(Theme.font.mediumSize, " !important"),
        fontWeight: Theme.font.boldWeight,
        paddingLeft: '50px !important',
        paddingRight: '50px !important'
      },
      outlinedSizeLarge: {
        height: 46,
        fontSize: "".concat(Theme.font.mediumSize, " !important"),
        fontWeight: Theme.font.boldWeight,
        paddingLeft: '50px !important',
        paddingRight: '50px !important'
      }
    },
    MuiTableHead: {
      root: {
        backgroundColor: "".concat(Theme.color.light, " !important")
      }
    },
    MuiTableRow: {
      root: {
        fontSize: "".concat(Theme.font.baseSize, " !important"),
        color: "".concat(Theme.font.baseColor, " !important"),
        paddingTop: '5px !important',
        paddingBottom: '5px !important'
      }
    },
    MuiTableCell: {
      head: {
        fontSize: "".concat(Theme.font.baseSize, " !important"),
        color: "".concat(Theme.font.baseColor, " !important"),
        fontWeight: "".concat(Theme.font.boldWeight, " !important")
      },
      body: {
        fontSize: "".concat(Theme.font.baseSize, " !important"),
        color: "".concat(Theme.font.baseColor, " !important"),
        fontWeight: "".concat(Theme.font.baseWeight, " !important")
      }
    },
    MuiSwitch: {
      colorSecondary: {
        '&$checked': {
          color: Theme.color.primary
        },
        '&$checked + $track': {
          backgroundColor: Theme.color.primary
        }
      }
    },
    MuiCheckbox: {
      colorSecondary: {
        '&$checked': {
          color: Theme.color.primary
        }
      }
    },
    MuiRadio: {
      colorSecondary: {
        '&$checked': {
          color: Theme.color.primary
        }
      }
    }
  },
  flatButton: {
    textTransform: 'none',
    fontSize: Theme.font.baseSize,
    buttonFilterColor: Theme.color.secondary
  },
  TableRowColumn: {
    whiteSpace: 'normal',
    wordWrap: 'break-word'
  },
  palette: {
    primary: {
      main: Theme.color.primary,
      contrastText: Theme.color.white
    },
    secondary: {
      main: Theme.color.secondary,
      contrastText: Theme.color.white
    },
    error: {
      main: Theme.color.danger,
      contrastText: Theme.color.white
    },
    warning: {
      main: Theme.color.warning,
      contrastText: Theme.color.feature
    },
    info: {
      main: Theme.color.info,
      contrastText: Theme.color.feature
    },
    success: {
      main: Theme.color.success,
      contrastText: Theme.color.feature
    },
    contrastThreshold: 3,
    tonalOffset: 0.2
  },
  typography: {
    fontFamily: Theme.font.baseFamily,
    body1: {
      fontSize: Theme.font.baseSize
    },
    button: {
      lineHeight: '150%',
      fontFamily: Theme.font.fancyFamily,
      textTransform: 'none',
      letterSpacing: 0
    }
  }
});
const ScreenSize = exports.ScreenSize = {
  mobile: '400px',
  tablet: '600px'
};
const ScrollableStyles = exports.ScrollableStyles = "\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: ".concat(Theme.color.white, ";\n  }\n\n  &::-webkit-scrollbar-track {\n    border-radius: 40px;\n    background: rgba(0, 0, 0, 0.1);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    border-radius: 10px;\n    background: ").concat(Theme.color.secondary, ";\n  }");
var _default = exports.default = Theme;